/**
 * "When a program exits" (Settings → Extensions → Terminal), like Windows
 * Terminal's `closeOnExit`:
 *  - 'clean'  (default) close the pane when its program exits with code 0 —
 *             e.g. typing `exit` in a shell;
 *  - 'always' close on any exit code;
 *  - 'never'  keep it, with the exit bar (Restart / Open shell here / Close).
 */
export const CLOSE_ON_EXIT_MODES = ['clean', 'always', 'never'];
export const DEFAULT_CLOSE_ON_EXIT = 'clean';

export function normalizeCloseOnExit(value) {
  return CLOSE_ON_EXIT_MODES.includes(value) ? value : DEFAULT_CLOSE_ON_EXIT;
}

/**
 * Whether a pane whose status just became `status` (with exit `code` and
 * `error` text) closes itself. Never, in any mode: a program that failed to
 * start (`'error'`), an exit that carries an error message (an SSH connect
 * failure is recorded as `'exited'` + null code + the error) — the user
 * needs the message — or the AI tab's pane. Under 'clean' also not an
 * unknown exit code (`null`, e.g. an SSH session that dropped).
 */
export function shouldCloseOnExit(mode, pane, status, code, error = null) {
  if (!pane || pane.ai || status !== 'exited' || error) return false;
  const m = normalizeCloseOnExit(mode);
  if (m === 'never') return false;
  if (m === 'always') return true;
  return code === 0;
}
